import React from 'react'

const LifeQuotes = () => {
    return (
        <div>
            <div className=' bg-gray-900 p-2'>
                {/* <h1 className=" text-3xl font-bold tracking-tight  sm:text-4xl text-center mt-6 text-white">
                ❝ Life Quotes ❞
                </h1> */}
                <p className="mb-3 font-Kalam text-center text-transparent bg-clip-text bg-gradient-to-r to-purple-500 from-red-400 text-3xl  mt-6 ">❛ The Only Time you Fail is when you Fall down and Stay Down ! ❜</p>

            </div>
        </div>
        
    )
}

export default LifeQuotes